<template>
  <div class="container-fluid p-0">
    <nav class="navbar navbar-expand-md bg-primary">
      <ul class="navbar-nav ml-auto">
        <!-- <li class="nav-item mr-2">
          <a class="nav-link" href="#">
            <vs-input icon="search" placeholder="Search" v-model="search" />
          </a>
        </li> -->

        <li class="nav-item dropdown mr-3 mt-1">
          <vs-dropdown>
            <a class="a-icon" href.prevent>
              <h6 class="text-white mt-2 text-capitalize">
                {{ currentUser }}
                <vs-icon class icon="expand_more"></vs-icon>
              </h6>
            </a>
            <vs-dropdown-menu class="loginx">
              <div class role="presentation"></div>
               <a
                class="dropdown-item"
                href="./Unodc_Manual_Review-converted.pdf"
                target="_blank"
                role="menuitem"
                >Help</a
              >
              <a
                class="dropdown-item"
                href="javascript:void(0)"
                @click.prevent="logout"
                role="menuitem"
                >Logout</a
              >
              
            </vs-dropdown-menu>
          </vs-dropdown>
        </li>
      </ul>
    </nav>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => ({
    activeItem: 0,
    search: "",
    currentUser: ""
  }),
  mounted() {
    if (localStorage.getItem("currentUser")) {
      var getName = JSON.parse(localStorage.getItem("currentUser"));
      this.currentUser = getName.name;
    }
  },
  methods: {
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    logout() {
      let self = this;
      this.openLoading();
      axios
        .get(localStorage.getItem("BASE_PATH") + "/logout"
        )
        .then(response => {
          
          this.closeLoading();
          if (response) localStorage.removeItem("token");
          localStorage.removeItem("currentUser");
          self.$router.push({ path: "/" });
        })
        .catch(error => {
          if (error) localStorage.removeItem("token");
          localStorage.removeItem("currentUser");
          self.$router.push({ path: "/" });
        });
    }
  }
};
</script>

<style scoped>
.icon-scale {
  vertical-align: bottom;
}

.examplex {
  display: flex;
  align-items: center;
  justify-content: center;
}
.examplex .a-icon {
  outline: none;
  text-decoration: none !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.examplex .a-icon i {
  font-size: 18px;
}
.icon-scale {
  color: #fff !important;
}
.vs-dropdown-menu .con-input {
  margin-bottom: 20px;
}
.loginx h3 {
  color: rgba(0, 0, 0, 0.5);
  text-align: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding-bottom: 5px;
}
.loginx p {
  max-width: 200px;
  font-size: 11px;
  padding: 5px;
}
.con-vs-dropdown--menu {
  width: 200px !important;
}

.bg-primary {
  background: #06a6e0 !important;
}

@media (max-width: 768px) {
  .navbar-nav {
    flex-direction: initial !important;
  }
}
</style>
